<template>
  <div>
    <div class="caseDetail_home">
      <Navigation></Navigation>

      <div class="caseDetail_header" v-if="CaseDetails > 1">
        <div class="caseDetail_header_1">
          <div class="caseDetail_header_item ivu-row ivu-row-start">
            <div @click="Details(1)" class="ivu-col ivu-col-span-3">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA0CAMAAAD2UzvkAAAAM1BMVEUAAABHR0dHR0dHR0dFRUVISEhGRkZHR0dGRkZGRkZHR0dHR0dGRkZGRkZGRkZGRkZHR0dfc3gNAAAAEHRSTlMAQL/fECDvn3/Pj29fMFCvjUQW6wAAAQNJREFUSMftlssSgyAMRSsh4ANL/v9ra5QZ7IjgtYvOdHo37eYknAjo4+vp7B1qEoND1ovIiFI8iGYGtZxCrkO1NMSolsbbO1r9X+tDLRe683BRqx1nAr9Rg1yN34NPkssZbeY4caYSlzjig52WOs080ea4P1L9lS0SaOMOgtR4cuPKafEs2NgneVWD/gMElUu1UcGoy9TSmKB1qR0o2Gu75RcSTO10QaCgL6wnCVKlXRCRWDjpVJ8ma9nivfKszjLNBI3K/yh2cyRdPjvorRpxzCzYBFMsSxjGfFZDmwV4+pQ2MpaINsuHfwSpebuiwBe1hz8K7DwZWTMUKdN+weFYvnlfLhEei4wimBEAAAAASUVORK5CYII="
                style="width: 12px; height: 12px; margin-right: 12px"
              />返回 病例詳細
            </div>
            <div class="ivu-col ivu-col-span-1">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAACAAQMAAAAWHlrzAAAABlBMVEUAAADa3eCx5VADAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjMBjZEAABtBgBYxHlnQAAAABJRU5ErkJggg=="
                style="width: 1px; height: 32px"
              />
            </div>
            <div
              @click="Details(2)"
              :class="CaseDetails == 2 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              影像資料
            </div>
            <div
              @click="Details(3)"
              :class="CaseDetails == 3 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              數位模型
            </div>
            <div
              @click="Details(4)"
              :class="CaseDetails == 4 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              設計詳單
            </div>
            <div
              @click="Details(5)"
              :class="CaseDetails == 5 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              3D方案說明
            </div>
            <div
              @click="Details(6)"
              :class="CaseDetails == 6 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              矯治器加工
            </div>
            <div
              @click="Details(7)"
              :class="CaseDetails == 7 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              病例進度
            </div>
            <div
              @click="Details(8)"
              :class="CaseDetails == 8 ? 'caseDetail_clicked' : ''"
              class="ivu-col ivu-col-span-2"
            >
              下載CT檔案
            </div>
          </div>
        </div>
      </div>
      <div class="caseDetail_content">
        <div v-if="CaseDetails == 1" class="caseDetail_content">
          <div class="caseDetail" style="height: 850px">
            <div class="page-container">
              <div class="left-nav-menu">
                <div class="faceImg">
                  <img
                    v-if="
                      data.frontal_avatar_url != null &&
                      data.frontal_avatar_url != ''
                    "
                    :src="data.frontal_avatar_url"
                    style="
                      width: 112px;
                      height: 112px;
                      object-fit: cover;
                      object-position: center center;
                    "
                  />
                  <img
                    v-else
                    class="dentist-img"
                    src="../img/default.png"
                    alt=""
                  />
                </div>

                <div class="package-bottom-line"></div>
                <ul class="left-menu-list">
                  <li class="menu-item" @click="Details(2)">
                    <span id="photoFilesIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">影像資料</span>
                  </li>
                  <li class="menu-item" @click="Details(3)">
                    <span id="dataFilesIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">數位模型</span>
                  </li>
                  <li class="menu-item" @click="Details(4)">
                    <span id="designDetailIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">設計詳單</span>
                  </li>
                  <li class="menu-item" @click="Details(5)">
                    <span id="tpIntroIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">3D设计说明</span>
                  </li>
                  <li class="menu-item" @click="Details(6)">
                    <span id="applianceProcessIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">矯治器加工</span>
                  </li>
                  <li class="menu-item" @click="Details(7)">
                    <span id="caseStageIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">病例進度</span>
                  </li>
                  <li class="menu-item" @click="Details(8)">
                    <span id="ctDownloadIcon" class="menuItemIcon"></span
                    ><span class="menuItemContent">CT文件下載</span
                    ><span id="ctDownloadIconFlag" style="display: none"></span>
                  </li>
                </ul>
              </div>
              <div class="main-content">
                <div class="case-info-detail-panel">
                  <div class="cameo-bg-image"></div>
                  <div class="case-info-detail">
                    <div class="case-info-content">
                      <span class="patient-name">{{ data.name }}</span>
                      <span class="case-tab">病例編號：</span
                      ><span class="caseItem"> {{ data.medical_number }} </span>
                      <span class="case-tab">治療診所：</span
                      ><span class="caseItem">be@me</span>
                      <span class="case-tab">治療方案：</span
                      ><span
                        class="caseItem"
                        style="height: 36px; width: 600px"
                        >{{ data.treatment_plan_desc }}</span
                      >
                      <span class="case-tab">出生日期：</span
                      ><span class="caseItem">{{ data.birthday }}</span>
                      <span class="case-tab">診斷資訊：</span
                      ><span class="caseItem" style="color: rgb(41, 97, 203)">{{
                        data.clinical_situation_str
                      }}</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btnDeleteCase ivu-btn ivu-btn-default ivu-btn-small"
                    id="deleteCase"
                    @click="DeleteCase()"
                    v-if="
                      DoctorInformation.permissions.indexOf(
                        'delete_medical_case'
                      ) !== -1
                    "
                  >
                    <span> 删除病例 </span>
                  </button>
                  <button
                    type="button"
                    class="btnModifyCase ivu-btn ivu-btn-default ivu-btn-small"
                    id="updateCase"
                    @click="ModifyCase()"
                    v-if="
                      DoctorInformation.permissions.indexOf(
                        'modify_complete_medical_case'
                      ) !== -1
                    "
                  >
                    <span> 修改病例 </span>
                  </button>
                  <ul class="fast-nav-menu">
                    <li class="fast-menu-item" @click="Details(2)">
                      <div id="pic-item-icon" class="item-icon"></div>
                      <span class="item-tab">影像資料</span>
                    </li>
                    <li class="fast-menu-item" @click="Details(3)">
                      <div id="stl-item-icon" class="item-icon"></div>
                      <span class="item-tab">數位模型</span>
                    </li>
                    <li class="fast-menu-item" @click="Details(4)">
                      <div id="design-detail-icon" class="item-icon"></div>
                      <span class="item-tab">設計詳單</span>
                    </li>
                    <li class="fast-menu-item" @click="Details(5)">
                      <div id="tp-intro-item-icon" class="item-icon"></div>
                      <span class="item-tab">3D方案說明</span>
                    </li>
                  </ul>
                </div>
                <div class="tp-list-container">
                  <div class="tp-files-list tp-files-list-little">
                    <div style="margin-bottom: 5px">
                      <div
                        v-for="item in SchemeVideo"
                        :key="item.id"
                        class="tp-list-content"
                      >
                        <div
                          @click="showDialog(item.id)"
                          class="tpInfoItem default-tp-info"
                        >
                          <div class="icon-video">
                            <i
                              style="color: #ff000a4a"
                              class="el-icon-video-play"
                            ></i>
                          </div>
                          <span
                            class="tpName"
                            style="color: rgb(255, 255, 255)"
                          >
                            {{ item.name }}</span
                          >
                          <span
                            class="tpCreateTime"
                            style="color: rgb(255, 255, 255)"
                            >{{ item.created_at }}</span
                          >

                          <button
                            v-if="item.audit == 0"
                            type="button"
                            class="tpApproved ivu-btn ivu-btn-default ivu-btn-small"
                          >
                            <span>未稽核</span>
                          </button>
                          <button
                            v-if="item.audit == 1"
                            type="button"
                            class="tpApproved ivu-btn ivu-btn-default ivu-btn-small"
                          >
                            <span>以稽核</span>
                          </button>
                          <button
                            v-if="item.audit == 2"
                            type="button"
                            class="tpApproved ivu-btn ivu-btn-default ivu-btn-small"
                          >
                            <span>未通過</span>
                          </button>
                        </div>
                      </div>
                      <el-dialog
                        title="方案視頻"
                        :visible.sync="dialogVisible"
                        width="30%"
                        :before-close="handleClose"
                        center
                        :show-close="false"
                      >
                        <div class="video">
                          <video
                            v-if="currentVideo.before_url"
                            width="320"
                            height="240"
                            controls
                          >
                            <source
                              :src="currentVideo.before_url"
                              type="video/mp4"
                            />
                            <source src="movie.ogg" type="video/ogg" />
                            您的瀏覽器不支持Video標籤。
                          </video>
                          <video
                            v-if="currentVideo.upper_url"
                            width="320"
                            height="240"
                            style="margin: 10px"
                            controls
                          >
                            <source
                              :src="currentVideo.upper_url"
                              type="video/mp4"
                            />
                            <source src="movie.ogg" type="video/ogg" />
                            您的瀏覽器不支持Video標籤。
                          </video>
                          <video
                            v-if="currentVideo.lower_url"
                            width="320"
                            height="240"
                            controls
                          >
                            <source
                              :src="currentVideo.lower_url"
                              type="video/mp4"
                            />
                            <source src="movie.ogg" type="video/ogg" />
                            您的瀏覽器不支持Video標籤。
                          </video>
                          <video
                            v-if="currentVideo.left_url"
                            width="320"
                            height="240"
                            controls
                          >
                            <source
                              :src="currentVideo.left_url"
                              type="video/mp4"
                            />
                            <source src="movie.ogg" type="video/ogg" />
                            您的瀏覽器不支持Video標籤。
                          </video>
                          <video
                            v-if="currentVideo.right_url"
                            width="320"
                            height="240"
                            controls
                          >
                            <source
                              :src="currentVideo.right_url"
                              type="video/mp4"
                            />
                            <source src="movie.ogg" type="video/ogg" />
                            您的瀏覽器不支持Video標籤。
                          </video>
                        </div>
                        <div
                          v-if="
                            currentVideo.audit == 0 &&
                            DoctorInformation.permissions.indexOf('audit') !==
                              -1
                          "
                          style="display: flex"
                        >
                          <div
                            style="
                              width: 45%;
                              text-align: left;
                              padding-left: 20px;
                            "
                          >
                            <h3 style="margin-bottom: 0px">進行醫生評審</h3>
                            <p style="margin-top: 0px">
                              完成評審將添加至左側醫生留言中
                            </p>

                            <el-radio v-model="radio" label="1">同意</el-radio>
                            <br /><br />
                            <el-radio v-model="radio" label="2">拒絕</el-radio>
                          </div>
                          <div style="width: 50%">
                            <br />
                            <el-input
                              type="textarea"
                              placeholder="請輸入稽核意見..."
                              v-model="textarea"
                              maxlength="150"
                              show-word-limit
                            >
                            </el-input>
                          </div>
                        </div>

                        <span slot="footer" class="dialog-footer">
                          <el-button
                            style="margin-right: 20px"
                            @click="dialogVisible = false"
                            >關閉</el-button
                          >
                          <el-button
                            v-if="
                              currentVideo.audit == 0 &&
                              DoctorInformation.permissions.indexOf('audit') !==
                                -1
                            "
                            type="primary"
                            @click="SubmitReview(currentVideo.uuid)"
                            >確 定</el-button
                          >
                        </span>
                      </el-dialog>
                    </div>
                  </div>
                </div>
                <div class="case-stage-container">
                  <div class="container-header">病例進度</div>
                  <div
                    @click="Details(7)"
                    class="foot-nav"
                    style="left: 49px; cursor: pointer; user-select: none"
                  >
                    查看全部病例進度
                  </div>
                  <div class="panel-content">
                    <ul
                      v-for="(item, index) in CaseProgress"
                      :key="index"
                      class="stage-list"
                    >
                      <li class="stageItem">
                        <span class="stageTime">{{ item.created_at }}</span>
                        <span class="stageContent">{{ item.type }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="orthodontic-process-container">
                  <div class="container-header">矯治器加工</div>
                  <div
                    @click="Details(6)"
                    class="foot-nav"
                    style="left: 149px; cursor: pointer; user-select: none"
                  >
                    查看歷史生產申請
                  </div>
                  <div class="panel-content">
                    <div class="stage-info-tab">已生產 / 總步數</div>
                    <span class="progress-stage-tab"
                      >U: &nbsp; {{ schedule.upper_done }}/{{
                        schedule.upper_total
                      }}</span
                    >
                    <el-progress
                      :percentage="
                        parseInt(
                          (schedule.upper_done / schedule.upper_total) * 100
                        )
                      "
                      v-if="
                        !isNaN(
                          parseInt(
                            (schedule.upper_done / schedule.upper_total) * 100
                          )
                        )
                      "
                      status="success"
                      :stroke-width="10"
                    ></el-progress>
                    <span class="progress-stage-tab"
                      >L: &nbsp; {{ schedule.lower_done }}/{{
                        schedule.lower_total
                      }}</span
                    >
                    <el-progress
                      :percentage="
                        parseInt(
                          (schedule.lower_done / schedule.lower_total) * 100
                        )
                      "
                      v-if="
                        !isNaN(
                          parseInt(
                            (schedule.lower_done / schedule.lower_total) * 100
                          )
                        )
                      "
                      status="success"
                      :stroke-width="10"
                    ></el-progress>
                    <span class="product-application-tab">最近生產申請</span>
                    <ul class="product-application"></ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="CaseDetails >= 2" class="imageInfo">
          <div v-if="CaseDetails >= 2" class="imageInfo_left">
            <div class="left_content">
              <div class="time_item">
                <div class="time_item_left">
                  <div class="time_item_left_vector"></div>
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAWlBMVEUAAAAqYcspYcspYcwkYM8pYcsoYcspYcsoYMsoYMsoYMspYMspYcsoYcsoYMsnYMopYcv///9DdNLk7PmhuuhRftXX4fXy9fy8ze+vxOxeiNihuulRftQ2a89rJaOrAAAAEHRSTlMA79+PEM+vn38/IG/vv19v132mcAAAAStJREFUOMuVlNuagyAMhIECIq424KFqt+//msu3bRNQpPa/ZZwkMoSl1I0WHIArbWp2iDQcIkRl87IL7MhJGw4ZRLfVod2WS1q2hUOUZISCAm2ubrl6ByneQ8r1qbMCiPXeu8B0j8U/zzYrQB6zQxa/KW4BGXsX0Y+AyMRwvLmEGylNEAqcAf3Q02OXIS/41eJ2zHhYM4OGLsNKf0jDiyEnHN6nmm5vygl7jBHDdLksNA21mAXnPi08X1oUh5kwvud/T4MBK7Zooiuc97olukKa5lEIhQjpMccx+6VNEITyMLikA7t5g36JIuYhNgxIDoQfpn+3YQVC2Nfa+fRcu9MLAGlLOsUIqQqrR3619ohO5GT8ynbYKmOHZTdSkbgZlO2pjVY8aIRu6vTkDwlgUC7UTVD3AAAAAElFTkSuQmCC"
                    class="time_item_left_img"
                  />
                </div>
                <div class="time_item_right">
                  <div class="time_item_right_1 time_item_right_1_cur">
                    設計階段
                  </div>
                  <div class="time_item_right_2 time_item_right_2_cur">
                    {{ EstablishmentTime.created_at }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 2" class="imageInfo_right">
            <div class="right_content">
              <div>
                <div class="right_content_header">影像資料</div>
                <div class="right_content_rectangle"></div>
              </div>
              <span> 設計階段 </span
              ><span
                style="
                  margin-left: 30px;
                  font-size: 12px;
                  color: rgb(132, 132, 132);
                "
                >{{ EstablishmentTime.created_at }}</span
              >
              <div class="imageInfo-face">
                <div class="imageInfo-face-title">影像資料</div>
                <div class="imageInfo-face-content">
                  <div style="display: inline-block">
                    <div class="photo-box">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              :src="data.frontal_avatar_url"
                              style="vertical-align: middle"
                            />
                          </div>
                        </div>
                      </div>
                      <p>正面像</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.frontal_smile_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>正面微笑像</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.right_side_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>右側面像</p>
                    </div>
                  </div>
                  <div style="margin-top: 20px">
                    <div class="photo-box">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.front_teeth_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>正面咬合像</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.upper_teeth_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>上牙列像</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.lower_teeth_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>下牙列像</p>
                    </div>
                  </div>
                  <div style="margin-top: 20px; display: inline-block">
                    <div class="photo-box">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.left_mouth_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>口内左側位像</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.right_mouth_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>口内右側位像</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="imageInfo-x">
                <div class="imageInfo-x-title">X光片</div>
                <div class="imageInfo-face-content">
                  <div style="display: inline-block">
                    <div class="photo-box">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.full_jaw_curved_slice_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>全頜曲面斷層片</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="
                                data.lateral_cephalometric_radiograph_img_url
                              "
                            />
                          </div>
                        </div>
                      </div>
                      <p>頭顱側位定位片</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="imageInfo-other">
                <div class="imageInfo-other-title">其他影像</div>
                <div class="imageInfo-face-content">
                  <div style="display: inline-block">
                    <div class="photo-box">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.other1_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>-</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.other2_img_url"
                            />
                            <div class="upload-list-cover"></div>
                          </div>
                        </div>
                      </div>
                      <p>-</p>
                    </div>
                    <div class="photo-box" style="margin-left: 20px">
                      <div class="ivu-card ivu-card-bordered">
                        <div class="ivu-card-body">
                          <div class="upload-list">
                            <img
                              style="vertical-align: middle"
                              :src="data.other3_img_url"
                            />
                          </div>
                        </div>
                      </div>
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="
                position: relative;
                width: 100%;
                height: 100%;
                top: 0px;
                left: 0px;
                z-index: 99998;
                opacity: 0.7;
                overflow: hidden;
                background-color: rgb(36, 35, 35);
                display: none;
              "
            >
              <div
                class="ivu-spin ivu-spin-default ivu-spin-fix ivu-spin-show-text"
                style="font-size: 35px"
              >
                <div class="ivu-spin-main">
                  <span class="ivu-spin-dot"></span>
                  <div class="ivu-spin-text">
                    <i
                      class="demo-spin-icon-load ivu-icon ivu-icon-ios-loading"
                      style="font-size: 45px"
                    ></i>
                    <div>Loading</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 3" class="imageInfo_right">
            <div class="right_content">
              <div class="right_content_header">數位模型</div>
              <div class="right_content_rectangle"></div>
              <div class="right_content_stlInfo">
                <span
                  style="
                    font-weight: 500;
                    font-size: 15px;
                    color: rgb(50, 50, 50);
                    height: 24px;
                    line-height: 24px;
                  "
                  >設計階段</span
                >
                <span
                  style="
                    margin-left: 30px;
                    font-size: 12px;
                    color: rgb(132, 132, 132);
                    height: 24px;
                    line-height: 24px;
                  "
                  >{{ lastData.created_at }}</span
                >
                <div class="stlInfo-3d">
                  <div>
                    <video
                      width="320"
                      height="240"
                      style="margin: 10px"
                      controls
                    >
                      <source :src="lastData.before_url" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      您的瀏覽器不支持Video標籤。
                    </video>
                    <video
                      width="320"
                      height="240"
                      style="margin: 10px"
                      controls
                    >
                      <source :src="lastData.upper_url" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      您的瀏覽器不支持Video標籤。
                    </video>
                    <video
                      width="320"
                      height="240"
                      style="margin: 10px"
                      controls
                    >
                      <source :src="lastData.lower_url" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      您的瀏覽器不支持Video標籤。
                    </video>
                    <video
                      width="320"
                      height="240"
                      style="margin: 10px"
                      controls
                    >
                      <source :src="lastData.left_url" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      您的瀏覽器不支持Video標籤。
                    </video>
                    <video
                      width="320"
                      height="240"
                      style="margin: 10px"
                      controls
                    >
                      <source :src="lastData.right_url" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      您的瀏覽器不支持Video標籤。
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 4" class="imageInfo_right">
            <div class="right_top">
              <div class="right_content_header">
                設計詳單
                <!-- <button
                  type="button"
                  class="btnDownloadTpIntro ivu-btn ivu-btn-default"
                >
                  <span>下载文件</span>
                </button> -->
              </div>

              <div class="right_content_rectangle">
                <span
                  style="
                    font-weight: 500;
                    font-size: 15px;
                    color: rgb(50, 50, 50);
                    height: 24px;
                    line-height: 24px;
                  "
                  >設計階段</span
                >
                <span
                  style="
                    margin-left: 30px;
                    font-size: 12px;
                    color: rgb(132, 132, 132);
                    height: 24px;
                    line-height: 24px;
                  "
                  >{{ EstablishmentTime.created_at }}</span
                >
                <div class="DesignSheet">
                  <div class="detailInfos-content">
                    <div class="detailInfos-content-1">
                      <span class="detailInfos-content-1-left"
                        >無托槽隱形矯治器設計單</span
                      >
                      <span class="detailInfos-content-1-right"
                        >訂單編號： <span>000000</span></span
                      >
                    </div>
                    <div class="detailInfos-content-left">
                      <div
                        style="
                          background: rgba(64, 128, 249, 0.27);
                          position: absolute;
                          width: 362px;
                          height: 4px;
                          left: 10px;
                          top: 34px;
                        "
                      ></div>
                      <div>
                        <div
                          class="detailInfos-content-key"
                          style="
                            width: 58px;
                            border-right: 0.6px solid rgb(50, 50, 50);
                          "
                        >
                          客戶組織
                        </div>
                        <div
                          class="detailInfos-content-val"
                          style="width: calc(95% - 60px)"
                        >
                          {{ DesignDetails.address.clinic }}
                        </div>
                      </div>
                      <div style="clear: both">
                        <div style="width: 55%">
                          <div
                            class="detailInfos-content-key"
                            style="
                              width: 58px;
                              border-right: 0.6px solid rgb(50, 50, 50);
                            "
                          >
                            醫生姓名
                          </div>
                          <div
                            class="detailInfos-content-val"
                            style="
                              width: calc(85% - 58px);
                              border-right: 0.6px solid rgb(50, 50, 50);
                            "
                          >
                            {{ DesignDetails.doctor.name }}
                          </div>
                        </div>
                        <div style="width: 48%; float: left">
                          <div
                            class="detailInfos-content-key"
                            style="
                              width: 59px;
                              border-right: 0.6px solid rgb(50, 50, 50);
                            "
                          >
                            聯繫方式
                          </div>
                          <div
                            class="detailInfos-content-val"
                            style="
                              width: calc(88% - 57px);
                              border-right: 0.6px solid rgb(50, 50, 50);
                            "
                          >
                            {{ DesignDetails.doctor.phone }}
                          </div>
                        </div>
                      </div>
                      <div style="clear: both">
                        <div
                          class="detailInfos-content-key"
                          style="
                            width: 58px;
                            height: 60px;
                            border-right: 0.6px solid rgb(50, 50, 50);
                          "
                        >
                          寄件地址
                        </div>
                        <div
                          class="detailInfos-content-val"
                          style="
                            width: calc(95% - 60px);
                            height: 60px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                          "
                        >
                          {{ DesignDetails.address.address }}
                        </div>
                      </div>
                      <div style="clear: both">
                        <div style="width: 54%">
                          <div
                            class="detailInfos-content-key"
                            style="
                              width: 58px;
                              border-right: 0.6px solid rgb(50, 50, 50);
                            "
                          >
                            患者姓名
                          </div>
                          <div
                            class="detailInfos-content-val"
                            style="width: calc(90% - 57px)"
                          >
                            {{ DesignDetails.name }}
                          </div>
                        </div>
                        <div style="width: 23%; float: left">
                          <div
                            class="detailInfos-content-key"
                            style="width: 50px"
                          >
                            性别
                          </div>
                          <div
                            class="detailInfos-content-val"
                            style="width: calc(79% - 51px)"
                          >
                            {{ DesignDetails.gender }}
                          </div>
                        </div>
                        <div style="width: 23%; float: left">
                          <div
                            class="detailInfos-content-key"
                            style="width: 50px"
                          >
                            年齡
                          </div>
                          <div
                            class="detailInfos-content-val"
                            style="width: calc(79% - 51px)"
                          >
                            {{ DesignDetails.age }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="detailInfos-content-key"
                        style="
                          clear: both;
                          height: 166px;
                          width: 97%;
                          border-right: 0.6px solid rgb(50, 50, 50);
                        "
                      >
                        <div
                          class="detailInfos-content-key"
                          style="width: 97%; height: 18px; border: none"
                        >
                          患者主訴
                        </div>
                        <div
                          class="detailInfos-content-val"
                          style="
                            width: 100%;
                            height: 148px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            border: none;
                          "
                        >
                          {{ DesignDetails.remarks }}
                        </div>
                      </div>
                      <div
                        class="detailInfos-content-key"
                        style="
                          clear: both;
                          height: 372px;
                          width: 97%;
                          border-right: 0.6px solid rgb(50, 50, 50);
                        "
                      >
                        <div
                          class="detailInfos-content-key"
                          style="width: 100%; height: 18px; border: none"
                        >
                          醫生治療方案
                        </div>
                        <div
                          class="detailInfos-content-val"
                          style="
                            width: 100%;
                            height: 348px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            border: none;
                          "
                        >
                          {{ DesignDetails.treatment_plan_desc }}
                        </div>
                      </div>
                    </div>
                    <div class="detailInfos-content-center">
                      <div
                        style="
                          background: rgba(64, 128, 249, 0.17);
                          position: absolute;
                          width: 270px;
                          height: 4px;
                          left: 372px;
                          top: 34px;
                        "
                      ></div>
                      <div class="detailInfos-content-center-key">
                        擬矯治牙弓
                      </div>
                      <div
                        class="detailInfos-content-center-val"
                        style="height: 37px"
                      >
                        <span class="notShow">{{
                          DesignDetails.plan.orthodontic_arch
                        }}</span>
                      </div>
                      <div class="detailInfos-content-center-key">拔牙情况</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 53px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{ DesignDetails.plan.tooth_pulling }}</span>
                        </div>
                      </div>
                      <div class="detailInfos-content-center-key">支抗</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 53px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <p class="notShow" style="margin: 0">
                          <span>{{ DesignDetails.plan.anchorage_left }}</span
                          ><br />
                          <span>{{ DesignDetails.plan.anchorage_right }}</span>
                        </p>
                      </div>
                      <div class="detailInfos-content-center-key">中線</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 53px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{
                            DesignDetails.plan.center_line_choice_up_str
                          }}</span>

                          <br />
                          <span>{{
                            DesignDetails.plan.center_line_choice_low_str
                          }}</span>
                        </div>
                      </div>
                      <div class="detailInfos-content-center-key">覆合</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 37px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <span class="notShow">{{
                          DesignDetails.plan.overbite_adjust
                        }}</span>
                      </div>
                      <div class="detailInfos-content-center-key">覆蓋</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 37px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{ DesignDetails.plan.cover_adjust_str }}</span>
                        </div>
                      </div>
                      <div class="detailInfos-content-center-key">磨牙關係</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 53px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{
                            DesignDetails.plan.molar_relationship_left
                          }}</span
                          ><br /><span>{{
                            DesignDetails.plan.molar_relationship_right
                          }}</span>
                        </div>
                      </div>
                      <div class="detailInfos-content-center-key">牙列擁擠</div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 53px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{
                            DesignDetails.plan.crowding_teeth_up_str
                          }}</span>
                          <br />
                          <span>{{
                            DesignDetails.plan.crowding_teeth_low_str
                          }}</span>
                        </div>
                      </div>
                      <div class="detailInfos-content-center-key">
                        牙齒移動步距角度
                      </div>
                      <div
                        class="detailInfos-content-center-val"
                        style="
                          height: 50px;
                          text-overflow: ellipsis;
                          overflow: hidden;
                        "
                      >
                        <div class="notShow">
                          <span>{{ DesignDetails.plan.angle }}</span
                          ><br /><span>{{ DesignDetails.plan.move }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="detailInfos-content-right">
                      <div
                        style="
                          background: rgba(64, 128, 249, 0.07);
                          position: absolute;
                          width: 365px;
                          height: 4px;
                          left: 642px;
                          top: 34px;
                        "
                      ></div>
                      <div class="detailInfos-content-right-key">
                        不可移動牙齒：
                        <div>
                          {{ DesignDetails.plan.unmovable_teeth }}
                        </div>
                      </div>

                      <div class="detailInfos-content-right-key">
                        不可粘接附件位置:
                        <div>
                          {{ DesignDetails.plan.accessory_teeth }}
                        </div>
                      </div>

                      <div class="detailInfos-content-right-key">
                        需預留間隙牙比特：
                        <div>
                          {{ DesignDetails.plan.interval_teeth }}
                        </div>
                      </div>

                      <div class="detailInfos-content-right-key">
                        不可鄰面去釉牙比特：
                        <div>
                          {{ DesignDetails.plan.adjacent_glaze }}
                        </div>
                      </div>

                      <div
                        class="detailInfos-content-key"
                        style="clear: both; height: 106px; width: 100%"
                      >
                        <div
                          class="detailInfos-content-key"
                          style="width: 100%; height: 18px; border: none"
                        >
                          診斷資訊
                        </div>
                        <div
                          class="detailInfos-content-val"
                          style="
                            width: 100%;
                            height: 83px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            border: none;
                          "
                        >
                          {{ data.clinical_situation_str }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="detailInfos-bottom">
                    <div class="detailInfos-bottom-1">
                      客戶： {{ DesignDetails.doctor.name }}
                    </div>
                    <div class="detailInfos-bottom-2">接單人：</div>
                    <div class="detailInfos-bottom-3">稽核人：</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 5" class="imageInfo_right">
            <div class="tpIntroPageHeader">3D方案說明</div>
            <div class="title-bottom-line"></div>
            <div class="tpIntroPageContent">
              <div class="tpIntroItemPanel">
                <div class="tpIntroItemTab">
                  <span class="tpIntroItemTitle">設計階段 1-1</span>
                  <span class="tpIntroItemTime">{{
                    EstablishmentTime.created_at
                  }}</span>
                </div>
                <div v-if="lastData.pdf">
                  <iframe
                    :src="lastData.pdf"
                    style="border: none; width: 100%; height: 100%"
                    id="ifr1"
                  ></iframe>
                  <a target="_blank" :href="lastData.pdf">點擊查看3D方案說明</a>
                </div>
                <div v-else>暫無3D方案說明</div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 6" class="imageInfo_right">
            <div class="orthodonticProcessTab">矯治器加工</div>
            <div class="title-bottom-line"></div>
            <div class="stage-adjust-panel">
              <span class="stage-adjust-tab">設計階段</span>
              <span class="stage-adjust-time">{{
                EstablishmentTime.created_at
              }}</span>
            </div>
            <div class="orthodonticProcessContainer">
              <div class="container-header">矯治器加工情况</div>
              <div class="panel-content">
                <div class="stage-info-tab">已生產/總步數</div>
                <span class="progress-stage-tab"
                  >U: &nbsp; {{ schedule.upper_done }}/{{
                    schedule.upper_total
                  }}</span
                >
                <el-progress
                  :percentage="
                    parseInt((schedule.upper_done / schedule.upper_total) * 100)
                  "
                  v-if="
                    !isNaN(
                      parseInt(
                        (schedule.upper_done / schedule.upper_total) * 100
                      )
                    )
                  "
                  status="success"
                  :stroke-width="10"
                ></el-progress>
                <span class="progress-stage-tab"
                  >L: &nbsp; {{ schedule.lower_done }}/{{
                    schedule.lower_total
                  }}</span
                >
                <el-progress
                  :percentage="
                    parseInt((schedule.lower_done / schedule.lower_total) * 100)
                  "
                  v-if="
                    !isNaN(
                      parseInt(
                        (schedule.lower_done / schedule.lower_total) * 100
                      )
                    )
                  "
                  status="success"
                  :stroke-width="10"
                ></el-progress>
                <span class="product-application-tab">最近生產申請</span>
                <ul class="product-application"></ul>
              </div>
            </div>
            <div class="rightPanel">
              <!--  <div class="stageAdjust">
                <div class="btnStageAdjust btnStageAdjustDisable">阶段调整</div>
              </div>
              <div class="process-follow-up-panel">
                <div class="container-header">加工后续</div>
                <span class="sendTab">矫治器默认发货10套/次</span>
                <div class="sendAddressTab">矫治器收货地址</div>
                <el-input
                  type="textarea"
                  :rows="2"
                  :disabled="true"
                  placeholder="请输入内容"
                  v-model="data.address_uid"
                >
                </el-input>
                <button
                  type="button"
                  class="btnSend ivu-btn ivu-btn-default ivu-btn-small btnSendDisable"
                >
                  <span>发起</span>
                </button>
                <span class="sendIntro"
                  >*如有地址更改、套数变更等需沟通事项，请直接联系区域业务经理
                  。</span
                >
              </div> -->
            </div>
          </div>
          <div v-if="CaseDetails == 7" class="imageInfo_right">
            <div class="right_content">
              <div class="right_content_header">病例進度</div>
              <div class="right_content_rectangle"></div>
              <div class="right_content_caseStatusInfo">
                <div class="caseStatusInfo-content">
                  <div style="overflow: auto; height: 736px">
                    <div
                      v-for="(item, index) in CaseProgress"
                      :key="index"
                      class="caseStatusInfo-item"
                    >
                      <div class="caseStatusInfo-item-time">
                        {{ item.created_at }}
                      </div>
                      <div class="caseStatusInfo-item-canvas">
                        <div>
                          <img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADrSURBVHgBpVOxEYMwDLRFk5ISOkZwQZEyTAArZIKMQNiANejIBLlMgDeIS8qUqSAvzuRILpc45u+M3zrpJZ2EFG9I03Q3DEMOWuAk1qz5wF5prc3SX85EKRUS0RH0IL6jtkK3p4ANPjMVDhjHUeNkLEJssJmdgqesUirElBNH9gSPq/AAWsloVvIBYnNuwbn0DyjWCiQkVoIFjPAEj5MFWuEJjFMTRnESnuCNDPq+N3Ech3hv/wyusYkNzUrcj2uw9a2YB/xBFfcoihr0tPlVCWfGtX/5mZawq10ii+KdtxkNeIu77brusvR/ADqiae+6j1WoAAAAAElFTkSuQmCC"
                          />
                        </div>
                        <div
                          style="
                            height: 42px;
                            border-left: 1px dashed rgb(50, 50, 50);
                            margin-left: 7px;
                            margin-top: -4px;
                          "
                        ></div>
                      </div>
                      <div class="caseStatusInfo-item-right">
                        {{ item.type }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="CaseDetails == 8" class="imageInfo_right">
            <div class="right_content">
              <div class="right_content_header">CT文件下載</div>
              <div class="right_content_rectangle"></div>
              <div class="right_content_fileDownload">
                <span
                  style="
                    font-weight: 500;
                    font-size: 15px;
                    color: rgb(50, 50, 50);
                  "
                  >設計階段</span
                ><span
                  style="
                    margin-left: 30px;
                    font-size: 12px;
                    color: rgb(132, 132, 132);
                  "
                  >{{ EstablishmentTime.created_at }}</span
                >
                <div class="ctFilePageContent">
                  <div class="ctFileList_no">
                    <img
                      src="data:image/png;base64,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"
                    />
                    <div
                      v-if="data.ct_file != null && data.ct_file != ''"
                      style="margin: 20px"
                    >
                      <i class="el-icon-download"></i
                      ><a :href="data.ct_file" target="_blank">下載CT檔案</a>
                    </div>
                    <div v-else style="margin: 20px">
                      <p>暫無CT檔案</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
  <script>
import Bottom from "@/components/Bottom.vue";
import Navigation from "@/components/Navigation.vue";
import {
  getRecord,
  schedule,
  getDesignDetails,
  deleteCase,
  getPlan,
  getProduction,
  review,
} from "@/api/outpatient";

export default {
  metaInfo: {
    link: [],
  },
  components: {
    Bottom,
    Navigation,
  },
  data() {
    return {
      caseDetailUuid: "",
      data: {},
      CaseDetails: 1,
      CaseProgress: {},
      DesignDetails: {},
      schedule: {},
      dialogVisible: false,
      currentVideo: {},
      SchemeVideo: [{}],
      lastData: "",
      radio: "",
      textarea: "",
      DoctorInformation: "",
    };
  },
  created() {
    this.caseDetailUuid = JSON.parse(localStorage.getItem("caseDetail"));
    // 患者信息
    getRecord(this.caseDetailUuid).then((res) => {
      if (res.code == 200) {
        this.data = res.data;
      }
    });
    // 病例進度
    schedule(this.caseDetailUuid).then((res) => {
      if (res.code == 200) {
        this.EstablishmentTime = res.data[res.data.length - 1];
        this.CaseProgress = res.data;
        this.CaseProgress.reverse();
      }
    });
    // 設計詳單
    getDesignDetails(this.caseDetailUuid).then((res) => {
      if (res.code == 200) {
        this.DesignDetails = res.data;
      }
    });
    // 视频
    getPlan(this.caseDetailUuid).then((res) => {
      if (res.code == 200) {
        this.SchemeVideo = res.data;
        console.log(this.SchemeVideo);

        if (res.data != "") {
          this.lastData = res.data[res.data.length - 1];
        }
      }
    });

    // 生产进度
    getProduction(this.caseDetailUuid).then((res) => {
      if (res.code == 200) {
        this.schedule = res.data;
      }
    });
    // 获取个人信息
    this.DoctorInformation = JSON.parse(
      localStorage.getItem("DoctorInformation")
    );
  },
  mounted() {},
  methods: {
    // 跳转
    Jump(route) {
      this.$router.push(route);
    },
    // 赋值
    Details(data) {
      this.CaseDetails = data;
    },
    // 视频弹框
    showDialog(id) {
      this.currentVideo = this.SchemeVideo.find((item) => item.id === id);
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.currentVideo = {};
      done();
    },
    // 提交审核
    SubmitReview(uuid) {
      var data = {
        dpid: uuid,
        uuid: this.caseDetailUuid,
        result: this.radio,
        opinion: this.textarea,
      };
      review(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("稽核成功");
          this.dialogVisible = false;

          location.reload();
        } else {
          this.$message.error("稽核失敗");
        }
      });
    },
    // 删除病例
    DeleteCase() {
      this.$confirm("此操作將永久删除該病例，是否繼續？", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            uuid: this.caseDetailUuid,
          };
          deleteCase(data).then((res) => {
            if (res.code == 200) {
              this.$router.push("/caseList");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 修改病例
    ModifyCase() {
      localStorage.setItem("PatientID", JSON.stringify(this.caseDetailUuid));
      this.$router.push("/addCase/patientInfoNew");
    },

    // // 预览图片
    // previewImg(item) {
    //   const view = this.$el.querySelector(".viewer").$viewer;
    //   view.show();
    //   this.url = item;
    // },
  },
};
</script>
  <style scoped>
.caseDetail_home {
  width: 100%;
  min-width: 1248px;
  background: #e9e9e9;
}
.caseDetail_header {
  width: 100%;
  height: 56px;
  left: 0px;
  top: 0px;
  background: #ffffff;
  text-align: center;
}
.caseDetail_header_1 {
  position: relative;
  width: 1248px;
  left: calc(50% - 1248px / 2);
  /* top: 7px; */
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  color: #848484;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.caseDetail_header_item {
  padding: 8px;
}
.ivu-row-start {
  justify-content: flex-start;
}
.ivu-row,
.ivu-row:after,
.ivu-row:before {
  display: flex;
}
.caseDetail_header_1 .ivu-col {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
}
.ivu-col-span-3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.ivu-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}
.ivu-col-span-1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}
.ivu-col-span-2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.caseDetail_content {
  width: 100%;
  height: 100%;
  padding: 24px;
  /* background: #bd1d1d; */
  /* min-height: 650px; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.caseDetail {
  width: 100%;
  height: 100%;
  position: relative;
}
.caseDetail .page-container {
  width: 1248px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}
.left-nav-menu {
  width: 224px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #ffffff;
}
.faceImg {
  height: 112px;
  width: 112px;
  overflow: hidden;
  margin: 24px 56px 16px 56px;
  border-radius: 56px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.package-bottom-line {
  width: 176px;
  height: 1px;
  background: #ececec;
  margin: 0 24px 16px 24px;
}
.left-menu-list {
  height: 392px;
  width: 168px;
  list-style: none;
  cursor: pointer;
  margin-left: 28px;
}
.left-menu-list .menu-item {
  height: 40px;
  display: block;
  width: 168px;
  padding: 7px 8px;
  font-size: 16px;
  font-weight: 400;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 16px;
}
.menuItemIcon {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACgUlEQVR4Xu2Y0W3CMBCGea8qBQioUl8YoSN0hA5QEneCjtCO0A1gg3aDjBAlROojIzBC6zOx5VwcfGdB4MGfZAVh//Q/++KzO5lEIpHIzZKIcpXmdbHM64N8/o3dpqL+TsTvCvsiAeavZRy1Q1AQED38wCKrthNRJrj/0sAEzkW1bYMocL8XPQNB0UtSsXuer2sBDT6HTMJKavQq4D4vOgD8vY9EVO9DqbcQzYY7IaE+2MLjC1+VxmzW7Od5s4G2WNeFFcjh/rV+wfohuD4MHKHK17zZw3j1hJRxjIH3yQTiGOOC46MDR6hfNjDvy/VZVn3qlfCNBTg+OlCF1otGfuHlWJVS8ILjPgzVRw+qsC12x9knMstKtQrwxH0Yqo8eVGEMwAPVRw+qMAbggeqjB1UYUu71OesmdiFAFzFqcVrqik0Yz/HRgSOUFfYLxj4QUkKnHHXFOD46cIQwk8aUp7paVXuD+1xwfHTgCtO2usIT92nu35pc/y6jarN8GLhC+wbnSiUrdWR/1esfguvDwBLCTiR2H+YekFU/eIiVZupecCfKJzzGBcuHDUmIjcs2lWf/ofSwTqK6Fb6diOTDxSkhuq8a4z4zAGghELP1toEkWZPjscApHycZEiZyxm3jsJtQjGPcgVQl3sWGfHhxCe08BuNDqcJCGlaX/zYQvAG4fJBwCfUZhrqHc1jKezL8Ntyf7e9dPki4hJxDGBe9uqME0C53cd52PB+NEsAl20UDUNUUlvqC7REVOJcPEsHCMxPsI1h4ZoJ96OMBLixjYh8AcZ+X9Lg7BP1D9izIiYO/rQJwHA692MfjazbwEDyB7RKqC/jYDYyfOtlGIpHIbfAPFQ1w9d1x6HUAAAAASUVORK5CYII=);
}
.menu-item .menuItemIcon {
  background-size: contain;
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 14px;
}
.menu-item .menuItemContent {
  display: inline-block;
  position: relative;
  bottom: 6px;
}
.menu-item:hover {
  background-color: #d2ffe8;
}
.main-content {
  width: 1024px;
  position: absolute;
  left: 224px;
  top: 0;
  bottom: 0;
  height: 100%;
  background: #ffffff;
}
.main-content .case-info-detail-panel {
  width: 1024px;
  height: 230px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(217, 230, 255, 0.51)),
    to(rgba(217, 230, 255, 0.04))
  );
  background: linear-gradient(
    180deg,
    rgba(217, 230, 255, 0.51) 0%,
    rgba(217, 230, 255, 0.04) 100%
  );
  position: relative;
}
.cameo-bg-image {
  position: absolute;
  width: 480px;
  height: 108px;
  left: 272px;
  top: 16px;
  background-image: url(/static/img/came_bg_img.5efc8be.png);
  background-size: contain;
  background-repeat: no-repeat;
}
.case-info-detail {
  padding: 24px 0 0 40px;
  height: 233px;
  width: calc(100% - 40px);
}
.case-info-content {
  width: calc(100% - 168px);
  margin-left: 0;
  display: block;
}
.patient-name {
  display: block;
  height: 34px;
  font-size: 24px;
  font-weight: 600;
}
.case-info-content .case-tab {
  display: block;
  height: 22px;
  width: 80px;
  float: left;
  color: #adadad;
  font-size: 14px;
  margin-top: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.case-info-content .caseItem {
  color: #323232;
  display: block;
  height: 22px;
  font-size: 14px;
  margin-top: 8px;
  max-width: 650px;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  user-select: auto;
}
.btnDeleteCase {
  position: absolute;
  top: 24px;
  height: 32px;
  width: 92px;
  right: 148px;
  font-size: 13px;
  color: #646464;
  border: 1px solid #c4c4c4;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 16px;
  font-weight: 400;
  cursor: pointer;
}
.btnModifyCase {
  position: absolute;
  top: 24px;
  height: 32px;
  width: 92px;
  right: 40px;
  font-size: 13px;
  color: #2961cb;
  border: 0.5px solid #c4c4c4;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 16px;
  font-weight: 400;
  cursor: pointer;
}
.fast-nav-menu {
  position: absolute;
  bottom: 70px;
  right: 40px;
  height: 82px;
  width: 322px;
  list-style: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.fast-nav-menu .fast-menu-item {
  height: 40px;
  width: 160px;
  display: block;
  margin: 0 1px 1px 0;
  background: rgba(217, 230, 255, 0.51);
  border-radius: 2px;
  float: left;
  position: relative;
  cursor: pointer;
}
.item-icon {
  height: 24px;
  width: 24px;
  /* display: inline-block; */
  margin: 8px 6px 8px 12px;
  float: left;
  background-size: contain;
}
.item-icon {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACgUlEQVR4Xu2Y0W3CMBCGea8qBQioUl8YoSN0hA5QEneCjtCO0A1gg3aDjBAlROojIzBC6zOx5VwcfGdB4MGfZAVh//Q/++KzO5lEIpHIzZKIcpXmdbHM64N8/o3dpqL+TsTvCvsiAeavZRy1Q1AQED38wCKrthNRJrj/0sAEzkW1bYMocL8XPQNB0UtSsXuer2sBDT6HTMJKavQq4D4vOgD8vY9EVO9DqbcQzYY7IaE+2MLjC1+VxmzW7Od5s4G2WNeFFcjh/rV+wfohuD4MHKHK17zZw3j1hJRxjIH3yQTiGOOC46MDR6hfNjDvy/VZVn3qlfCNBTg+OlCF1otGfuHlWJVS8ILjPgzVRw+qsC12x9knMstKtQrwxH0Yqo8eVGEMwAPVRw+qMAbggeqjB1UYUu71OesmdiFAFzFqcVrqik0Yz/HRgSOUFfYLxj4QUkKnHHXFOD46cIQwk8aUp7paVXuD+1xwfHTgCtO2usIT92nu35pc/y6jarN8GLhC+wbnSiUrdWR/1esfguvDwBLCTiR2H+YekFU/eIiVZupecCfKJzzGBcuHDUmIjcs2lWf/ofSwTqK6Fb6diOTDxSkhuq8a4z4zAGghELP1toEkWZPjscApHycZEiZyxm3jsJtQjGPcgVQl3sWGfHhxCe08BuNDqcJCGlaX/zYQvAG4fJBwCfUZhrqHc1jKezL8Ntyf7e9dPki4hJxDGBe9uqME0C53cd52PB+NEsAl20UDUNUUlvqC7REVOJcPEsHCMxPsI1h4ZoJ96OMBLixjYh8AcZ+X9Lg7BP1D9izIiYO/rQJwHA692MfjazbwEDyB7RKqC/jYDYyfOtlGIpHIbfAPFQ1w9d1x6HUAAAAASUVORK5CYII=);
}
.fast-nav-menu .fast-menu-item .item-tab {
  font-size: 14px;
  font-weight: 400;
  color: #2961cb;
  display: inline-block;
  height: 22px;
  margin-top: 10px;
}
.tp-list-container {
  width: 100%;
  height: auto;
  clear: both;
  display: block;
  position: relative;
}

.tp-files-list {
  width: 952px;
  margin: 5px 40px 27px 32px;
  position: relative;
  overflow-x: auto;
  display: -webkit-box;
}

.tp-list-content {
  overflow: hidden;

  display: table-cell;
}
.default-tp-info {
  background-image: url(https://beame.oss-cn-hongkong.aliyuncs.com/mobilePicture/cases-4.png);
  background-size: contain;
}
.tpInfoItem {
  display: block;
  width: 272px;
  height: 107px;
  float: left;
  margin-right: 24px;
  padding: 12px 16px;
  position: relative;
  border-radius: 4px;
  cursor: pointer;
}
.tpInfoItem .tp-play-status {
  background-size: contain;
  width: 32px;
  height: 32px;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.tpInfoItem .tpName {
  display: block;
  font-size: 15px;
  font-weight: 500;
  margin: 5px 0;
}
.tpInfoItem .tpCreateTime {
  display: block;
  font-size: 12px;
  margin: 5px 0;
}
.tpInfoItem .tpApproved {
  background: #cfcfcf;
  border-radius: 2px;
  font-size: 13px;
  height: 28px;
  width: 80px;
  color: #ffffff;
  border: none;
  margin-top: 8px;
}
.case-stage-container {
  margin: 5px 24px 56px 32px;
  width: 428px;
  border: 1px solid #dadde0;
  border-radius: 4px;
  height: 424px;
  float: left;
  position: relative;
}

.foot-nav {
  font-size: 13px;
  font-weight: 400;
  padding: 5px 24px;
  height: 32px;
  width: 215px;
  position: absolute;
  text-align: center;
  bottom: 24px;
  left: 0;
  color: #646464;
  z-index: 3;
  background: #f8f8f8;
  border: 1px solid #c4c4c4;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 0 auto;
}
.panel-content .stage-list {
  list-style: none;
}
.stage-list .stageItem {
  line-height: 19px;
  display: block;
  height: 36px;
  font-size: 13px;
}
.stageItem .stageTime {
  display: inline-block;
  margin: 5px 10px 0 15px;
  height: 19px;
  width: 140px;
}
.stageItem .stageContent {
  display: inline-block;
  height: 19px;
}
.orthodontic-process-container {
  margin: 5px 40px 56px 0;
  width: 480px;
  border: 1px solid #dadde0;
  border-radius: 4px;
  height: 424px;
  float: left;
  position: relative;
}

.btnStageAdjust {
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  height: 40px;
  width: 217px;
  padding: 9px 0 0 42px;
  color: #474747;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.stage-info-tab {
  clear: both;
  margin-top: 16px;
  height: 18px;
  width: 100px;
  font-size: 11px;
  color: #848484;
}
.progress-stage-tab {
  font-size: 14px;
  font-weight: 500;
  display: block;
  height: 22px;
  width: 100px;
  margin-top: 4px;
}

.product-application-tab {
  display: block;
  font-size: 12px;
  margin: 16px 0 12px 0;
  color: #555555;
  height: 19px;
}
.imageInfo {
  position: relative;
  width: 1248px;
  height: 1000px;
  margin: 0 auto;
  background: #ffffff;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
}

.imageInfo_left {
  width: 200px;
  height: 100%;
  float: left;
  border-right: 1px solid #dadde0;
}
.left_content {
  height: 100%;
  /* overflow-y: scroll; */
  padding: 32px 25px;
}
.time_item {
  /* display: flex; */
  height: 60px;
  clear: both;
  cursor: pointer;
}
.time_item_left {
  float: left;
  display: block;
  height: 60px;
  width: 10px;
}
.time_item_left_vector {
  width: 1px;
  height: 100%;
  border-left: #dadde0 1px solid;
  margin: 0 auto;
}
.time_item_left_img {
  width: 10px;
  height: 10px;
  -webkit-transform: translateY(-60px);
  transform: translateY(-60px);
}
.time_item_right {
  font-weight: 500;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 20px;
}
.time_item_right_1 {
  font-size: 15px;
}
.time_item_right_2 {
  font-size: 12px;
}
.imageInfo_right {
  width: calc(100% - 201px);
  height: 100%;
  /* background: #33ff36; */
  float: right;
}

.right_top {
  padding: 20px 60px 0px 40px;
}
.right_content_header {
  width: 129px;
  height: 38px;
  font-weight: 600;
  font-size: 24px;
  color: #323232;
}
.right_content_rectangle {
  height: 1px;
  background: #ececec;
  margin-top: 16px;
}
.imageInfo-face {
  position: absolute;
  left: 14px;
  top: 112px;
}
.imageInfo-face-title,
.imageInfo-x-title,
.imageInfo-other-title {
  width: 80px;
  height: 32px;
  font-size: 13px;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: right;
  color: #323232;
  float: left;
}
.imageInfo-face-content {
  float: left;
  margin-left: 20px;
}
.photo-box {
  width: 160px;
  height: 149px;
  text-align: center;
  float: left;
}
.photo-box .ivu-card {
  width: 160px;
  height: 120px;
  margin-bottom: 8px;
}
.photo-box .ivu-card-body {
  padding: 0 !important;
}
.upload-list {
  line-height: 120px;
}
.ivu-card img {
  max-width: 160px;
  max-height: 120px;
}

.imageInfo-x {
  position: absolute;
  left: 14px;
  top: 615px;
  margin-top: 20px;
}
.imageInfo-other {
  position: absolute;
  left: 14px;
  top: 796px;
  margin-top: 20px;
}
.caseDetail_content {
  width: 100%;
  height: 100%;
  padding: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.photo-box .ivu-card {
  width: 160px;
  height: 120px;
  margin-bottom: 8px;
}

.ivu-card-bordered {
  border: 1px solid #e8eaec;
}
.ivu-card {
  display: block;
  background: #fff;
  border-radius: 4px;
  font-size: 14px;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.photo-box p {
  font-size: 13px;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  color: #323232;
  margin-bottom: 20px;
}
.caseDetail_clicked {
  background: #f2f1f1;
  border-radius: 8px;
}
.right_content {
  position: absolute;
  width: calc(98% - 200px);
  height: 100%;
  padding: 20px 10px 20px 20px;
}
.btnDownloadTpIntro {
  position: absolute;
  top: 24px;
  right: 32px;
  width: 120px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #848484;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 2px;
  color: #323232;
  font-size: 14px;
}
.tpIntroPageHeader {
  margin: 24px 0 16px 40px;
  height: 32px;
  font-size: 24px;
  color: #323232;
  font-weight: 600;
}
.title-bottom-line {
  height: 1px;
  width: calc(100% - 100px);
  margin: 0 60px 16px 40px;
  background: #ececec;
}
.tpIntroItemPanel .tpIntroItemTab {
  height: 24px;
  width: 320px;
  margin-bottom: 16px;
}

.tpIntroPageContent {
  height: 520px;
  margin: 0 60px 16px 40px;
}
.tpIntroItemPanel {
  /* height: 220px;
  width: 320px; */
  margin: 0 40px 40px 0;
  float: left;
  cursor: pointer;
}
.tpIntroItemTab .tpIntroItemTitle {
  color: #323232;
  font-weight: 500;
  font-size: 15px;
  height: 24px;
  margin-right: 10px;
  width: 113px;
  display: inline-block;
}
.tpIntroItemTab .tpIntroItemTime {
  color: #848484;
  font-size: 12px;
  font-weight: 400;
  display: inline-block;
  height: 19px;
  width: 150px;
}
.orthodonticProcessTab {
  margin-top: 24px;
  margin-left: 40px;
  height: 32px;
  font-size: 24px;
  font-weight: 600;
  color: #323232;
}
.title-bottom-line {
  height: 1px;
  width: calc(100% - 100px);
  margin: 16px 60px 16px 40px;
  background: #ececec;
}
.stage-adjust-panel {
  height: 24px;
  margin: 0 60px 16px 40px;
}
.stage-adjust-panel .stage-adjust-tab {
  font-size: 15px;
  font-weight: 500;
  color: #323232;
  width: 113px;
  margin-right: 8px;
  display: inline-block;
}
.orthodonticProcessContainer {
  width: 486px;
  margin-left: 40px;
  border: 1px solid #dadde0;
  border-radius: 4px;
  height: 446px;
  float: left;
  position: relative;
}
.container-header {
  height: 44px;
  /* width: 100%; */
  border-bottom: 1px solid #dadde0;
  padding: 12px 0 0 20px;
  margin-bottom: 5px;
  color: #323232;
  font-weight: 500;
}
.panel-content {
  width: calc(100% - 30px);
  margin: 0 20px 30px 20px;
  height: calc(100% - 150px);
  overflow-y: auto;
}
.stage-info-tab {
  margin-top: 16px;
  height: 18px;
  width: 100px;
  font-size: 11px;
  color: #848484;
}
.progress-stage-tab {
  font-size: 14px;
  font-weight: 500;
  display: block;
  height: 22px;
  width: 100px;
  margin-top: 4px;
}

.panel-content .ivu-progress-outer {
  padding-right: 0;
  margin-right: 0;
}

.panel-content .ivu-progress-text {
  position: absolute;
  right: 2px;
  top: -24px;
  font-size: 14px;
  font-weight: 500;
}
.progress-stage-tab {
  font-size: 14px;
  font-weight: 500;
  display: block;
  height: 22px;
  width: 100px;
  margin-top: 4px;
}

.product-application-tab {
  display: block;
  font-size: 12px;
  margin: 16px 0 12px 0;
  color: #555555;
  height: 19px;
}
.product-application {
  list-style: none;

  height: calc(100% - 200px);
}
.rightPanel {
  float: left;
  width: 240px;
  height: 500px;
  margin-left: 16px;
}
.stageAdjust {
  padding: 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.btnStageAdjust {
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  height: 40px;
  width: 217px;
  padding: 9px 0 0 42px;
  color: #474747;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.process-follow-up-panel {
  width: 240px;
  height: 365px;
  border: 1px solid #dadde0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 17px;
}

.sendTab {
  margin-top: 11px;
  display: block;
  height: 19px;
  margin-left: 20px;
  color: #323232;
  font-size: 13px;
  font-weight: 500;
}
.sendAddressTab {
  margin-left: 20px;
  margin-top: 12px;
  height: 19px;
  font-size: 13px;
  font-weight: 500;
  color: #000000;
}
.btnSend {
  background: #4080f9;
  border-radius: 4px;
  color: #ffffff;
  height: 32px;
  width: 200px;
  margin: 0 20px 8px 20px;
  font-size: 13px;
  border: 1px solid #4080f9;
  font-weight: 500;
}
.sendIntro {
  display: block;
  margin: 0 20px 0 20px;
  font-size: 11px;
  color: #77a6fd;
  padding: 2px;
}

.right_content_header {
  width: 129px;
  height: 38px;
  font-weight: 600;
  font-size: 24px;
  color: #323232;
}

.right_content_caseStatusInfo {
  margin-top: 16px;
  height: 265px;
}
.caseStatusInfo-content {
  position: absolute;
  /* width: 232px; */
  height: 736px;
  left: 40px;
  top: 96px;
}
.caseStatusInfo-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.caseStatusInfo-item-time {
  width: 80px;
  height: 38px;
  font-size: 12px;
  line-height: 160%;
  text-align: right;
  color: #555555;
  display: block;
  float: left;
}
.caseStatusInfo-item-canvas {
  margin-left: 16px;
  float: left;
  display: block;
}
.caseStatusInfo-item-canvas img {
  margin-top: 2px;
}
.caseStatusInfo-item-right {
  height: 19px;
  font-size: 12px;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000000;
  margin-left: 24px;
  float: left;
}
.ctFilePageContent {
  margin-top: 16px;
  height: 225px;
  width: 300px;
  border-radius: 0px;
}
.ctFileList_no {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  display: flex;
  align-content: stretch;
  flex-wrap: nowrap;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
}
.ctFileList_no img {
  height: 120px;
  width: 120px;
  margin: 32px auto 10px auto;
}

.DesignSheet {
  position: absolute;
  width: 1015px;
  height: 754px;
  right: 20px;
  top: 130px;
  background: rgba(0, 0, 0, 0.03);
}

.detailInfos-content {
  position: absolute;
  width: 1000px;
  /* height: 680px
px
; */
  left: 0px;
  top: 0px;
  padding: 12px 10px 28px 10px;
}
.detailInfos-content-1 {
  width: 95%;
}
.detailInfos-content-1-left {
  width: 176px;
  height: 26px;
  font-size: 16px;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  color: #000000;
}
.detailInfos-content-1-right {
  width: 273px;
  height: 18px;
  font-size: 12px;
  line-height: 160%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: right;
  float: right;
  color: #000000;
}
.detailInfos-content-left {
  width: 362px;
  height: 688px;
  border-left: 0.6px solid #323232;
  border-bottom: 0.6px solid #323232;
  float: left;
}
.detailInfos-content-key {
  border-top: 0.6px solid #323232;
  float: left;
  font-size: 12px;
  line-height: 160%;
  color: #323232;
  padding: 1px 4px;
  height: 24px;
}
.detailInfos-content-val {
  height: 20px;
  border-top: 0.6px solid #323232;
  border-right: 0.6px solid #323232;
  float: left;
  font-size: 12px;
  line-height: 160%;
  color: #000000;
  padding: 1px 4px;
  height: 24px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.detailInfos-content-center {
  width: 270px;
  height: 688px;
  border-bottom: 0.6px solid #323232;
  float: left;
}
.detailInfos-content-center-key {
  width: 100%;
  border-top: 0.6px solid #323232;
  font-size: 12px;
  line-height: 160%;
  color: #323232;

  height: 24px;
  background: #e6edfb;
}
.detailInfos-content-center-val {
  width: 97%;
  height: 20px;
  border-top: 0.6px solid #323232;
  font-size: 12px;
  line-height: 160%;
  color: #000000;
  padding: 1px 4px;
  height: 24px;
}
.detailInfos-content-right {
  width: 360px;
  height: 688px;
  border-left: 0.6px solid #323232;
  border-right: 0.6px solid #323232;
  border-bottom: 0.6px solid #323232;
  float: left;
}
.detailInfos-bottom {
  position: absolute;
  width: 185px;
  height: 23px;
  left: 0px;
  top: 719px;
  width: 100%;
  height: 40px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 160%;
  color: #000000;
}
.detailInfos-bottom-1 {
  position: absolute;
  width: 210px;
  height: 23px;
  left: 330px;
  top: 10px;
}
.detailInfos-bottom-2 {
  position: absolute;
  width: 250px;
  height: 23px;
  left: 540px;
  top: 10px;
}
.detailInfos-bottom-3 {
  position: absolute;
  width: 250px;
  height: 23px;
  left: 790px;
  top: 10px;
}

.detailInfos-content-right-key {
  width: 98%;
  border-top: 0.6px solid #323232;
  font-size: 12px;
  line-height: 160%;
  color: #323232;
  padding: 2px 4px;
  height: 120px;
}
.el-textarea >>> .el-textarea__inner {
  min-height: 134px !important;
  max-height: 134px;
  margin: 10px 20px;
  width: 200px;
}
.icon-video {
  font-size: 30px;
  float: right;
}
.video {
  text-align: center;
}
h2,
h3,
h4,
h5,
button,
a {
  font-family: "GenSenMaruGothicTW-Bold";
}
p,
span,
div {
  font-family: "GenSenMaruGothicTW-Regular";
}
</style>